export enum DateTimeType {
  Day = "DAY",
  TimeWindow = "TIMEWINDOW",
  Hour = "HOUR",
  NotImplemented = "NOTIMPLEMENTED"
}
